import React, {FC, useEffect} from 'react'

import cn from 'classnames/bind'
import Link from 'next/link'

import PortableBlocks from 'components/blocks/PortableBlocks'
import Button from 'components/elements/Button'
import {Container, Row, Col} from 'components/elements/grid'
import ToggleableTextGroup from 'components/elements/ToggleableTextGroup'
import {FaqPage} from 'src/types/__sanitySchema__'
import {posthogTrack, klaviyoTrack} from 'src/utils'

import s from './TemplateFaq.module.scss'
const cx = cn.bind(s)

interface ITemplateFaqProps {
	pageContent: FaqPage
	className?: string
}

const TemplateFaq: FC<ITemplateFaqProps> = ({pageContent, className}) => {
	useEffect(() => {
		klaviyoTrack('Page opened', {page: 'faq', href: window?.location?.href})
	}, [])

	return (
		<div className={cx('page-wrapper', className)}>
			<Container>
				<Row>
					<Col>
						<h1 className={cx('title')}>{pageContent.title || ''}</h1>
						<p className={cx('description')}>{pageContent.description}</p>
						{pageContent.faq?.faqCategories?.map((category) => {
							return (
								<div key={category._key} className={cx('category')}>
									<h2 className={cx('category__header')}>{category.faqCategoryTitle}</h2>
									{category.faqCategoryQuestions?.map((item) => {
										return (
											<div key={item._key} className={cx('item')}>
												<ToggleableTextGroup header={item.faqItemTitle || ''}>
													{/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
													<PortableBlocks blockContent={item.faqItemDescription!} />
												</ToggleableTextGroup>
											</div>
										)
									})}
								</div>
							)
						})}
						<h2 className={cx('questions-header')}>Do You Still Have Questions?</h2>
						<p>Click the chat button and contact us today.</p>
						<div className={cx('button-wrapper')}>
							<Link href="/make-your-paystub" passHref legacyBehavior>
								<Button
									size="responsive"
									className={s.list__btn}
									as="a"
									onClick={() => {
										posthogTrack('[FAQ] Create A Pay Stub Now Button clicked')
									}}>
									Create A Pay Stub Now
								</Button>
							</Link>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

TemplateFaq.displayName = 'TemplateFaq'

export default TemplateFaq
